<template>
  <div class="pcmain"  :style="isgrey == '1' ? { filter: 'grayscale(100%)' } : ''">
    <router-view></router-view>
  </div>
</template>
<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { contentlistAllNews, contentlistAllNotices, managerlistConfig, categorylistAll } from '@/api/demo'
import store from '@/store';
let isgrey = ref()

let list = ref([])
onBeforeMount(() => {
  managerlistConfig()
  console.log("appphone");
})

managerlistConfig({ type: "color" }).then(res => {
  if (res.code == 100000) {
    res.data.map(v => {
      if (v.name == 'grey') {
        isgrey.value = v.intValue.toString()
      }
      if (v.name == 'red') {
        if (v.intValue == '1') {
          store.commit('updateColor10', 'red')
        }
      }
    })
  } else {
    ElMessage.error(res.description);
  }
})
</script>
<style lang="scss" scoped></style>
